module.exports = __webpack_public_path__ + "img/active-layer9.e365f69a.png";